module.exports = __webpack_public_path__ + "static/media/IDSPennyHomeLogoInterstitial.9bd30542.svg";